export const stateOptions = [
  { id: 'NY', name: 'New York' },
  { id: 'AK', name: 'Alaska' },
  { id: 'AL', name: 'Alabama' },
  { id: 'AR', name: 'Arkansas' },
  { id: 'AS', name: 'American Samoa' },
  { id: 'AZ', name: 'Arizona' },
  { id: 'CA', name: 'California' },
  { id: 'CO', name: 'Colorado' },
  { id: 'CT', name: 'Connecticut' },
  { id: 'DC', name: 'District of Columbia' },
  { id: 'DE', name: 'Delaware' },
  { id: 'FL', name: 'Florida' },
  { id: 'GA', name: 'Georgia' },
  { id: 'GU', name: 'Guam' },
  { id: 'HI', name: 'Hawaii' },
  { id: 'IA', name: 'Iowa' },
  { id: 'ID', name: 'Idaho' },
  { id: 'IL', name: 'Illinois' },
  { id: 'IN', name: 'Indiana' },
  { id: 'KS', name: 'Kansas' },
  { id: 'KY', name: 'Kentucky' },
  { id: 'LA', name: 'Louisiana' },
  { id: 'MA', name: 'Massachusetts' },
  { id: 'MD', name: 'Maryland' },
  { id: 'ME', name: 'Maine' },
  { id: 'MI', name: 'Michigan' },
  { id: 'MN', name: 'Minnesota' },
  { id: 'MO', name: 'Missouri' },
  { id: 'MP', name: 'Northern Mariana Islands' },
  { id: 'MS', name: 'Mississippi' },
  { id: 'MT', name: 'Montana' },
  { id: 'NA', name: 'National' },
  { id: 'NC', name: 'North Carolina' },
  { id: 'ND', name: 'North Dakota' },
  { id: 'NE', name: 'Nebraska' },
  { id: 'NH', name: 'New Hampshire' },
  { id: 'NJ', name: 'New Jersey' },
  { id: 'NM', name: 'New Mexico' },
  { id: 'NV', name: 'Nevada' },
  { id: 'OH', name: 'Ohio' },
  { id: 'OK', name: 'Oklahoma' },
  { id: 'OR', name: 'Oregon' },
  { id: 'PA', name: 'Pennsylvania' },
  { id: 'PR', name: 'Puerto Rico' },
  { id: 'RI', name: 'Rhode Island' },
  { id: 'SC', name: 'South Carolina' },
  { id: 'SD', name: 'South Dakota' },
  { id: 'TN', name: 'Tennessee' },
  { id: 'TX', name: 'Texas' },
  { id: 'UT', name: 'Utah' },
  { id: 'VA', name: 'Virginia' },
  { id: 'VI', name: 'Virgin Islands' },
  { id: 'VT', name: 'Vermont' },
  { id: 'WA', name: 'Washington' },
  { id: 'WI', name: 'Wisconsin' },
  { id: 'WV', name: 'West Virginia' },
  { id: 'WY', name: 'Wyoming' }
];

export const aboutUsOptions = [
  { id: 1, name: 'Google Maps' },
  { id: 2, name: 'Google Search' },
  { id: 4, name: 'Facebook or Instagram Post/Ad' },
  { id: 5, name: 'Signage/Walked by' },
  { id: 6, name: 'Friend/Family' },
  { id: 7, name: 'Flyer' },
  { id: 8, name: 'Yelp' },
  { id: 9, name: 'Other' }
];
